import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import { trackPageView } from '@/utils/analytics';
import UserInteractionContext from '@/Providers/UserInteractionContextProvider/UserInteractionContext';

/**
 * Component to track page views on route changes
 * Automatically tracks page views with device information
 */
const PageViewTracker = () => {
  const location = useLocation();
  const { platform } = useContext(PageContext);
  const { identifierInputValue, ssoEmail } = useContext(UserInteractionContext);

  const payload = {
    search: location.search,
    hash: location.hash,
    platformContext: platform, // From PageContext
    ssoEmail,
    identifierType: identifierInputValue?.type ?? '',
    identifierValue: identifierInputValue?.value ?? '',
  };
  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname, payload);
  }, [location.pathname, location.search, location.hash, platform]);

  return null; // This component doesn't render anything
};

export default PageViewTracker;

